<div class="row justify-content-center mt-3">
    <div class="col-xl-8 col-lg-8">
        <div class="text-center">
            <p class="text-muted">{{parametro.mensajeSoportePortalTransaccional}}</p>
        </div>
    </div>
</div>